import { Grid, Tabs, Tab } from "@mui/material";
import { observer } from "mobx-react";
import HomePageStore from "../store/HomePageStore";
interface Props {
  pageStore: HomePageStore;
}
function PersonCountArea(props: Props) {
  const { pageStore } = props;
  return (
    <Grid container item direction='row' justifyContent={'flex-end'} columnGap={2} style={{ marginTop: '16px' }}>
      <Grid
        item
        style={{
          fontFamily: 'Pretendard',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '13px',
          lineHeight: '13px',
          color: '#585858',
        }}
      >
        Appraisees : <span style={{ color: '#249EE7' }}>{pageStore.total}</span>
      </Grid>
      <Grid
        item
        style={{
          fontFamily: 'Pretendard',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '13px',
          lineHeight: '13px',
          color: '#585858',
          marginRight: '20px',
        }}
      >
        Items : <span style={{ color: '#249EE7' }}>{pageStore.appraisee}</span>
      </Grid>
    </Grid>
  );
}

export default observer(PersonCountArea);
